<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<script>
import Vue from "vue";

export default Vue.extend({
  props: {
    params: Object,
    isNotEditable: {
      type: Boolean,
      default: false,
    },
    forceNotEditable: {
      type: Boolean,
      default: false,
    },
    isLiffMode: {
      type: Boolean,
      default: false,
    },
    isAdminMode: {
      type: Boolean,
      default: false,
    },
    isConfirmSurveyMode: {
      type: Boolean,
      default: false,
    },
    isQuiryKey: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      return this.params.title;
    },
    description() {
      return this.params.description;
    },
    disabled() {
      // if(this.isConfirmSurveyMode && this.isQuiryKey){
      if (this.forceNotEditable) {
        return true;
      } else if (this.isConfirmSurveyMode) {
        return false;
      }
      return this.isNotEditable && this.isLiffMode;
    },
  },
  methods: {},
});
</script>
